import React, { useState } from 'react';
import updateUserProgress from './userProgressTrack/updateUserProgress';


const DecisionComponent = ({ options, onSelect, currentStep, userId, area, nextStep, handleNextStep }) => {
  const [isSelecting, setIsSelecting] = useState(false);

  const handleOptionSelect = async (nextStep, text) => {
    if (isSelecting) return; // Prevent double execution
    setIsSelecting(true);

    try {
      const areaName = area;
      await updateUserProgress(userId, areaName, nextStep);
      onSelect(nextStep, text);
      await handleNextStep();

    } catch (error) {
      console.error("Error selecting option:", error);
    } finally {
      setIsSelecting(false); // Reset flag after completion
    }
    window.location.reload();
  };

  return (
    <div>
      {currentStep === 21 ? (
        <div>
          <h1 className="uppercase text-center text-xl font-bold">Wealth Building Track</h1>
          <div className="space-y-4 mt-4">
            {options.map((option, index) => (
              <div key={index} className="border border-black p-5 bg-white text-center rounded-md">
                <p><strong>{option.text}</strong></p>
                <button
                  onClick={() => handleOptionSelect(option.nextStep, option.text)}
                  className="mt-4 mr-3 px-8 py-3 text-black border border-black font-semibold rounded-full hover:bg-[#f8ae51] transition-colors"
                  disabled={isSelecting}
                >
                  Select
                </button>
              </div>
            ))}
          </div>
          <small className="uppercase flex justify-center mt-3">Double Tap button to Start</small>
        </div>
      ) : (
        <div className="flex max-[992px]:flex-col min-h-screen w-full max-[992px]:pt-8">
          <div className="min-[992px]:w-1/2 flex flex-col justify-center items-start min-[1300px]:pt-24 min-[992px]:pr-20 max-[992px]:pr-6 pl-6">
          <h1 className="text-4xl font-extrabold orange-text mb-6">Unlock Full Access</h1>
          <p>Congratulations on Passing the Masterclass!
              <br />
              <br />
              You've taken an important first step on your journey with the DIFF Center by
              mastering How to Become a Transformative Black Visionary Leader. This
              milestone demonstrates your commitment to understanding the roots of
              Black economic disparity and preparing yourself as an empowered change
              agent within our community.
              <br />
              <br />
              Now that you’ve scored 100% on the test, you’re ready to unlock the full
              potential of the DIFF Center. Here’s how to access everything we offer:
              <br />
              <br />
              <ul class="accordion-list">
                        <li>
                          <details>
                            <summary><strong>Step 1: Record Your Testimonial <span className="text-red-700">(Coming Soon)</span></strong></summary>
                            <p> Share a few words about how the masterclass impacted you. With your
              consent, your testimonial will be featured in our community to inspire others
              on a similar path.</p>
                          </details>
                        </li>
                        <li>
                          <details>
                            <summary><strong>Step 2: Dive Into Your Learning Tracks</strong></summary>
                            <p> 
                            With full access, explore our two main tracks designed to support your goals:</p>
                            <br />
                            <ul class="disc">
                                <li><strong>Finances & Philanthropy</strong>: Access tools and insights for building personal and communal wealth.</li>
                                <li><strong>Entrepreneurship & Philanthropy</strong>: Learn how to create a community-centered business that generates wealth and gives back.</li>
                              </ul>
                              <br />
                              Each track includes targeted workshops, expert interviews, and practical
                              tools tailored to help you achieve personal, generational, and community-
                              wide success.
                          </details>
                        </li>


                      </ul>
      <br />
              Welcome to the DIFF Center—where you can lead boldly, grow strategically,
              and create a lasting impact. Now, let’s get started!
              </p>
          {/* <StepHeader 
            className="text-center"
                area="" 
              /> */}
              </div>
          {/* <div className="md:flex md:text-center sm:block md:flex-row items-center align-center justify-center space-y-4 mt-4"> */}
          <div className="relative flex items-center justify-center min-[992px]:w-2/3 max-[992px]:mt-8">
  <div className="grid grid-cols-2 w-full">
    {options.map((option, index) => (
      <div
        key={index}
        onClick={() => handleOptionSelect(option.nextStep, option.text)}
        className={`relative group min-h-80 min-[995px]:min-h-screen cursor-pointer overflow-hidden transition-transform transform hover:scale-95 ${isSelecting ? 'pointer-events-none opacity-50' : ''}`}
        style={{
          backgroundImage: `url(${require(`../../assets/decision-img-${index + 1}.png`)})`, // Replace with the actual image URLs
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-40 transition-opacity group-hover:bg-opacity-50 mb-0 flex flex-col items-center justify-center">
          <h2 className="text-white font-semibold text-xl text-center">{option.text}</h2>
          <small className="uppercase flex justify-center text-white max-[995px]:mt-4">Click to Start</small> 
        </div>
      </div>
    ))}
  </div>
</div>

          {/* <small className="uppercase flex justify-center mt-3">Double Tap button to Start</small> */}
        </div>
      )}
    </div>
  );
};

export default DecisionComponent;
